import React from 'react'
import '../Poster/Poster.css'
const Poster = () => {
    return (
      <div className="poster">
        <div className="overlay">
          <div className="content">
            <p className="tagline">Finding Treasures Beneath Every Rock</p>
            <h1 className="title">Leading Excellence In </h1>
           
            
            <div className="row-content">
            <button className="contact-button">Contact Us</button>
              <h1 className="extra-title">Mining</h1>
              <p className="extra-description">Our mining services are designed to meet the growing demand for critical resources. </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Poster;